module.exports = "../static/media/B25Binge-light.55b5d8f1.png";